import React from 'react';
import { IconArrowRight, IconWhatsApp } from './icons';
type Variant = 'gold' | 'outline' | 'outlineLight' | 'whatsapp' | 'solidLight';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  /** Full width on mobile, auto from sm up. */
  block?: boolean;
  /** Slides in on hover. On by default for gold and outline CTAs. */
  withArrow?: boolean;
  children: React.ReactNode;
}
const BASE = 'group relative inline-flex min-h-[54px] items-center justify-center gap-2.5 overflow-hidden px-7 text-[13px] font-bold uppercase leading-none tracking-[0.14em] transition-all duration-300 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:translate-y-0';
const VARIANTS: Record<Variant, string> = {
  // The single gold-filled conversion CTA. Deep gold text, soft lift, warm shadow.
  gold: 'bg-gold text-golddeep shadow-[0_1px_0_0_rgba(46,34,5,0.18)] hover:-translate-y-[2px] hover:shadow-[0_10px_24px_-12px_rgba(46,34,5,0.55)] active:translate-y-0',
  outline: 'border border-ink/85 text-ink hover:-translate-y-[2px] hover:bg-ink hover:text-white active:translate-y-0',
  outlineLight: 'border border-white/40 text-white hover:-translate-y-[2px] hover:border-gold hover:text-gold active:translate-y-0',
  whatsapp: 'bg-whatsapp text-golddeep hover:-translate-y-[2px] hover:shadow-[0_10px_24px_-12px_rgba(37,211,102,0.7)] active:translate-y-0',
  solidLight: 'bg-white text-ink hover:-translate-y-[2px] active:translate-y-0'
};
export function Button({
  variant = 'gold',
  block = false,
  withArrow,
  children,
  className = '',
  ...props
}: ButtonProps) {
  const showArrow = withArrow ?? (variant === 'gold' || variant === 'outline' || variant === 'outlineLight');
  return <button {...props} className={`${BASE} ${VARIANTS[variant]} ${block ? 'w-full' : 'w-full sm:w-auto'} ${className}`} data-id="element-28" data-mp="3ljcyb18md8xl">
      {variant === 'whatsapp' && <IconWhatsApp className="h-[18px] w-[18px]" data-id="element-29" data-mp="1joud9mg039hy" />}
      <span data-id="element-30" data-mp="1i8qdyp87innc">{children}</span>
      {showArrow && <IconArrowRight className="h-[18px] w-[18px] -translate-x-1 opacity-0 transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100" strokeWidth={1.8} data-id="element-31" data-mp="1i9hz1646h2zd" />}
      {/* Thin gold hairline that sweeps across on hover — the signature detail. */}
      <span aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-px origin-left scale-x-0 bg-current opacity-30 transition-transform duration-500 group-hover:scale-x-100" data-id="element-32" data-mp="13cr7tk4nqxku" />
    </button>;
}